import { _ } from "../../../core/polyglot/polyglot.js";
import AbstractValueFormulaToken from "./AbstractValueFormulaToken.js";
import AccountFormulaNode from "../formula/AccountFormulaNode.js";
import AccountNumberListSpecification from "../../accountSpecification/AccountNumberListSpecification.js";

/**
 * Value token representing a single account.
 *
 * @param {string} spec.accountNumber - Number of the account represented by the
 * token.
 */
export default class AccountFormulaToken extends AbstractValueFormulaToken {
	constructor({ accountNumber } = {}) {
		super(...arguments);
		this._accountNumber = accountNumber;
	}

	getAccountNumber() {
		return this._accountNumber;
	}

	setAccountNumber(accountNumber) {
		this._accountNumber = accountNumber;
	}

	accept(visitor) {
		return visitor.visitAccountFormulaToken(this);
	}

	_asBaseFormulaNode() {
		return new AccountFormulaNode({
			accountSpecification: new AccountNumberListSpecification({
				accountNumbers: [this._accountNumber],
			}),
		});
	}

	static getLabel() {
		return _("Account");
	}

	static getType() {
		return "account";
	}
}
